import imageProduct1 from "../assets/images/Items/item1.jpg";
import imageProduct2 from "../assets/images/Items/item2.jpg";
import imageProduct3 from "../assets/images/Items/item3.jpg";
import imageProduct4 from "../assets/images/Items/item4.jpg";
import imageProduct5 from "../assets/images/Items/item5.jpg";
import imageProduct6 from "../assets/images/Items/item6.jpg";
import imageProduct7 from "../assets/images/Items/item7.jpg";
import imageProduct8 from "../assets/images/Items/item8.jpg";
import imageProduct9 from "../assets/images/Items/item9.jpg";
import imageProduct10 from "../assets/images/Items/item10.jpg";
import imageProduct11 from "../assets/images/Items/item11.jpg";
import imageProduct12 from "../assets/images/Items/item12.jpg";



export const items = [
    {

        id: 1,
        name: "Sevelian Shirt",
        price: 101,
        image: imageProduct1,
        description: "Mollit anim consectetur adipisicing aute pariatur ad mollit ad. Officia amet aliqua non laborum dolore sint sit eu sit sunt laboris.",
        slug: "sevelian-shirt"
    },
    {
        id: 2,
        name: "Arden Classic T-Shirt",
        price: 150,
        image: imageProduct2,
        description: "Elegant and versatile T-shirt made from premium cotton for a soft, comfortable feel. Perfect for everyday wear.",
        slug: "arden-classic-tshirt"
    },
    {
        id: 3,
        name: "Urban Sneaker",
        price: 220,
        image: imageProduct3,
        description: "High-quality sneakers designed for ultimate comfort and style. Perfect for casual and athletic use.",
        slug: "urban-sneaker"
    },
    {
        id: 4,
        name: "Felicity Dress",
        price: 349,
        image: imageProduct4,
        description: "A stunning dress for special occasions. Crafted with precision to enhance your elegance.",
        slug: "felicity-dress"
    },
    {
        id: 5,
        name: "Nexus Backpack",
        price: 299,
        image: imageProduct5,
        description: "Durable and spacious backpack with multiple compartments. Ideal for travel and daily use.",
        slug: "nexus-backpack"
    },
    {
        id: 6,
        name: "Horizon Sunglasses",
        price: 120,
        image: imageProduct6,
        description: "Stylish sunglasses with UV protection. A must-have accessory for sunny days.",
        slug: "horizon-sunglasses"
    },
    {
        id: 7,
        name: "Atlas Leather Wallet",
        price: 85,
        image: imageProduct7,
        description: "Handcrafted leather wallet with multiple card slots. Sleek and functional design.",
        slug: "atlas-leather-wallet"
    },
    {
        id: 8,
        name: "Vertex Running Shoes",
        price: 199,
        image: imageProduct8,
        description: "Lightweight and breathable running shoes designed for peak performance.",
        slug: "vertex-running-shoes"
    },
    {
        id: 9,
        name: "Eclipse Smartwatch",
        price: 450,
        image: imageProduct9,
        description: "Advanced smartwatch with fitness tracking, notifications, and more.",
        slug: "eclipse-smartwatch"
    },
    {
        id: 10,
        name: "Harbor Denim Jacket",
        price: 275,
        image: imageProduct10,
        description: "Classic denim jacket with a modern twist. Perfect for layering and casual wear.",
        slug: "harbor-denim-jacket"
    },
    {
        id: 11,
        name: "Opal Ceramic Mug",
        price: 40,
        image: imageProduct11,
        description: "Elegant ceramic mug for your favorite beverages. Dishwasher and microwave safe.",
        slug: "opal-ceramic-mug"
    },
    {
        id: 12,
        name: "Luna Table Lamp",
        price: 125,
        image: imageProduct12,
        description: "Chic table lamp with adjustable brightness. Adds a warm ambiance to any room.",
        slug: "luna-table-lamp"
    },


]